import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TipoAliquotaService from "./tipoAliquotaService"
import FormList from 'base/FormList'

export default function TipoAliquotaList() {

    const [service] = useState(() => new TipoAliquotaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tipali',
        dsName: 'descricao_tipali',
        mainField: { name: 'descricao_tipali', label: '' },
        advFields: [
            { name: 'codigo_tipali', label: 'Código', type: 'integer', inputMode: 'numeric' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_tipali" sortable header="Código"></Column>
            <Column field="descricao_tipali" sortable header="Descrição" style={{ whiteSpace: 'normal' }}></Column>
        </FormList >
    )
}
